import React, { useEffect, useState } from 'react'
import PageHeading from '../../../components/PageHeading'
import { useNavigate, useParams } from 'react-router-dom';
import GetProjectPlotByProjectId from '../../../APIs/PlotSpecification/GetProjectPlotByProjectId';
import InsertProjectPlotSpecification from '../../../APIs/PlotSpecification/InsertProjectPlotSpecification';
import Loader from '../../../components/Loader';
import SideMessage from '../../../components/SideMessage';
import UpdateProjectPlotSpecification from '../../../APIs/PlotSpecification/UpdateProjectPlotSpecification';
export default function PlotSpecification() {
    const projectId = JSON.parse(window.sessionStorage.getItem("ProjectData")).projectId
    const [sendForm, setSendForm] = useState({
        "id": 0,
        "projectId": projectId,
        "dimension_0": null,
        "dimension_1": null,
        "area": null,
        "noOfPlots": null,
        "perPlotCost": null,
        "userId": 0,
    })
    const [plotSpecification, setPlotSpecification] = useState([]);
    // const [totalArea, setTotalArea] = useState(0);
    let { productionCost, totalArea } = useParams();
    const navigate = useNavigate();
    let [sideToster, setSideToster] = useState({
        show: 0,
        message: '',
        type: ''
    })
    const [isUpdate, setIsUpdate] = useState(false)
    let [loader, setLoader] = useState(0);

    const calculateUsedArea = () => {
        let existingArea = plotSpecification.reduce((sum, item) => {
            return sum + (item.area * item.noOfPlots);
        }, 0);

        let currentArea = sendForm.area * sendForm.noOfPlots;

        // 👇 IMPORTANT: exclude current item when updating
        if (isUpdate) {
            const editingItem = plotSpecification.find(p => p.id === sendForm.id);
            if (editingItem) {
                existingArea -= (editingItem.area * editingItem.noOfPlots);
            }
        }

        return existingArea + currentArea;
    };

    const getData = async () => {
        let response = await GetProjectPlotByProjectId(projectId)
        try {
            if (response.status === 1) {
                setPlotSpecification(response.responseValue)
            }
            else {
                setPlotSpecification([])
            }
        }
        catch (e) {
            setPlotSpecification([])
        }

    }
    const handleChange = (e) => {
        let { name, value } = e.target;
        value = parseFloat(value || 0);
        if (value >= 0) {
            if (name === 'dimension_0') {
                let area = value * sendForm.dimension_1;
                let perPlotCost = (area * productionCost).toFixed(2);
                // let perPlotCost = area * productionCost;
                setSendForm((prev) => ({ ...prev, [name]: sendForm.dimension_0 === 0 ? value.toString().replace(/^0+/, 0) : value, area: area, perPlotCost: perPlotCost }))
            }
            else if (name === 'dimension_1') {
                let area = sendForm.dimension_0 * value;
                let perPlotCost = (area * productionCost).toFixed(2);
                // let perPlotCost = (area * productionCost);
                setSendForm((prev) => ({ ...prev, [name]: sendForm.dimension_1 === 0 ? value.toString().replace(/^0+/, 0) : value, area: area, perPlotCost: perPlotCost }))
            }
            else {
                setSendForm((prev) => ({ ...prev, [name]: sendForm.noOfPlots === 0 ? value.toString().replace(/^0+/, 0) : value }))
            }
        }


    }

    const handleRedirect = (data) => {
        navigate("/defineplotsequencing/" + data?.id)
    }

    const handleOnSave = async () => {
        try {
            if (sendForm.noOfPlots > 0 && sendForm.dimension_0 > 0 && sendForm.dimension_1 > 0) {
                const totalUsedArea = calculateUsedArea();

                if (totalUsedArea > totalArea) {
                    setSideToster({
                        show: 1,
                        message: "Total area exceeded!",
                        type: 'Alert'
                    });
                    return;
                }
                setLoader(1)
                let response = await InsertProjectPlotSpecification(sendForm)
                if (response.status === 1) {
                    setSideToster({
                        show: 1,
                        message: "Data Save!!",
                        type: 'success'
                    })
                    setLoader(0);
                    setSendForm({
                        "id": 0,
                        "projectId": projectId,
                        "dimension_0": 0,
                        "dimension_1": 0,
                        "area": 0,
                        "noOfPlots": 0,
                        "perPlotCost": 0,
                        "userId": 0,
                    })
                    getData();
                }
                else {
                    setSideToster({
                        show: 1,
                        message: response.responseValue,
                        type: 'Alert'
                    })
                    setLoader(0)
                }
            }
            else {
                if (sendForm.dimension_0 <= 0 || sendForm.dimension_1 <= 0) {
                    setSideToster({
                        show: 1,
                        message: "Please Fill Dimension",
                        type: 'Alert'
                    })
                    setLoader(0)
                }
                else {
                    setSideToster({
                        show: 1,
                        message: "Please Fill No of Plots",
                        type: 'Alert'
                    })
                    setLoader(0)
                }

            }
        }
        catch (e) {
            setSideToster({
                show: 1,
                message: expect.message,
                type: 'Alert'
            })
        }
    }

    const handleUpdate = async () => {

        try {
            if (sendForm.noOfPlots > 0 && sendForm.dimension_0 > 0 && sendForm.dimension_1 > 0) {
                const totalUsedArea = calculateUsedArea();

                if (totalUsedArea > totalArea) {
                    setSideToster({
                        show: 1,
                        message: "Total area exceeded!",
                        type: 'Alert'
                    });
                    return;
                }
                setLoader(1)
                let response = await UpdateProjectPlotSpecification(sendForm)
                if (response.status === 1) {
                    setSideToster({
                        show: 1,
                        message: "Data Update!!",
                        type: 'success'
                    })
                    setLoader(0);
                    setSendForm({
                        "id": 0,
                        "projectId": projectId,
                        "dimension_0": 0,
                        "dimension_1": 0,
                        "area": 0,
                        "noOfPlots": 0,
                        "perPlotCost": 0,
                        "userId": 0,
                    })
                    setIsUpdate(false);
                    getData();
                }
                else {
                    setSideToster({
                        show: 1,
                        message: response.responseValue,
                        type: 'Alert'
                    })
                    setLoader(0)
                }
            }
            else {
                if (sendForm.dimension_0 <= 0 || sendForm.dimension_1 <= 0) {
                    setSideToster({
                        show: 1,
                        message: "Please Fill Dimension",
                        type: 'Alert'
                    })
                    setLoader(0)
                }
                else {
                    setSideToster({
                        show: 1,
                        message: "Please Fill No of Plots",
                        type: 'Alert'
                    })
                    setLoader(0)
                }

            }
        }
        catch (e) {
            setSideToster({
                show: 1,
                message: expect.message,
                type: 'Alert'
            })
        }
    }

    const handleEdit = (val) => {
        setSendForm({
            ...val,
            "dimension_0": parseFloat(val.dimensions.split("*")[0]),
            "dimension_1": parseFloat(val.dimensions.split("*")[1]),
            "userId": window.userId,

        });
        setIsUpdate(true);

    }

    const handleCancel = () => {
        setSendForm({
            "id": 0,
            "projectId": projectId,
            "dimension_0": 0,
            "dimension_1": 0,
            "area": 0,
            "noOfPlots": 0,
            "perPlotCost": 0,
            "userId": 0,
        })
        setIsUpdate(false);
    }

    useEffect(() => {
        getData();
    }, [])
    return (
        <div className='container-fluid landformconatiner p-4_' id="conatinerId">
            <div className='container-fluid landformconatiner p-4_'>
                {/* <PageHeading pagename={"Plot Specification"} /> */}
                <div className='container-fluid landformconatiner p-4'>
                    <PageHeading pagename={"Plot Specification"} />
                    <div className='wrapform pt-3'>
                        <div className='d-flex flex-column gap-1 w-100'>
                            <label className='form-label d-flex flex-row justify-content-between'>Dimensions</label>
                            <div className='d-flex flex-row gap-2'>
                                <div>
                                    <label>Width</label>
                                    <input type='number' className='form-input-box w-100' value={sendForm.dimension_0} placeholder='Enter Width' name='dimension_0' onChange={handleChange} />
                                </div>
                                <div>
                                    <label>Length</label>
                                    <input type='number' className='form-input-box w-100' value={sendForm.dimension_1} placeholder='Enter Height' name='dimension_1' onChange={handleChange} />
                                </div>
                            </div>

                        </div>
                        <div className='d-flex flex-column gap-1 mt-2 mt-lg-4'>
                            <label className='form-label d-flex flex-row justify-content-between'>Area</label>
                            <input type='number' className='form-input-box' value={sendForm.area} placeholder='Enter Area' name='area' disabled={true} />

                        </div>
                        <div className='d-flex flex-column gap-1   mt-2 mt-lg-4'>
                            <label className='form-label d-flex flex-row justify-content-between'>Per Plots Cost</label>
                            <input type='number' className='form-input-box' value={sendForm.perPlotCost} placeholder='Enter Per Plot Cost' name='perPlotCost' disabled={true} />
                        </div>
                        <div className='d-flex flex-row align-items-center gap-2   mt-2 mt-lg-3 mt-xl-0'>

                            <div className='d-flex flex-column justify-content-center gap-2'>
                                <label className='form-label d-flex flex-row justify-content-between'>No Of Units</label>

                                <input type='number' className='form-input-box' value={sendForm.noOfPlots} placeholder='Enter No Of Units' name='noOfPlots' onChange={handleChange} />
                            </div>
                            {
                                !isUpdate
                                    ?
                                    <button className='btn export-save-btn mt-4 h-50' onClick={handleOnSave}> Save </button>
                                    :
                                    <div className='d-flex flex-row gap-2'>
                                        <button className='btn export-save-btn mt-4 h-50' onClick={handleUpdate}> Update </button>
                                        <button className='btn export-save-btn mt-4 h-50' onClick={handleCancel}> Cancel </button>
                                    </div>
                            }
                        </div>
                    </div>





                    <div className='pt-4'>
                        <div style={{ height: "60vh", overflow: "auto" }}>
                            <table class="table">
                                <thead>
                                    <tr className='table-head'>
                                        <th scope="col">#</th>
                                        {/* <th scope="col">State</th> */}
                                        <th scope="col">Dimensions</th>
                                        <th scope="col">Area</th>
                                        <th scope="col">Per Plots Cost</th>
                                        <th scope="col">No Of Units</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody className='table-body'>
                                    {
                                        plotSpecification && plotSpecification.map((val, ind) => {
                                            return (
                                                <tr >
                                                    <td scope="row">{ind + 1}</td>
                                                    {/* <td>{stateName}</td> */}
                                                    <td>{val.dimensions}</td>
                                                    <td>{val.area}</td>
                                                    <td>{Math.round(val.perPlotCost).toFixed(2)}</td>
                                                    <td>{val.noOfPlots}</td>
                                                    <td>
                                                        <div class="dropdown dropend">
                                                            <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                            <ul className="dropdown-menu mr-3">
                                                                {

                                                                    <>
                                                                        <li><span className="dropdown-item" onClick={() => { handleEdit(val) }}>Edit</span></li>
                                                                        <li><span className="dropdown-item" onClick={() => { handleRedirect(val) }}>Add Sequencing</span></li>
                                                                        {/* <li><span className="dropdown-item" onClick={() => { handleDelete(val.id) }}>Delete</span></li> */}
                                                                    </>

                                                                }
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }


                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Loader show={loader} />
            {
                sideToster.show === 1 ?
                    <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />
                    : ""
            }
        </div>
    )
}
